import SessionEventProto from "../session-event-proto"

import ProjectProperties from "../../model2/project/properties/project-properties"
import {SESSION_PROJECT_CHANGE} from "../../gd/bus/bus-event-type"
import asyncSessionLoader from "../../gd/data/async-session-loader"

export default class EventProjectChange extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    validate() {
        return true
    }

    async process() {
        const pinId = gd.session.pins.getPinId({projectId:this.data.id})
        if (pinId) {
            const pin = gd.session.pins.get(pinId)
            if (!pin?.project) return

            pin.project.name        = this.data.name
            pin.project.color       = this.data.color
            pin.project.systemType  = this.data.systemType
        }

        const sessionTemplate = gd.session.templatesList.get(this.data.id)

        if (sessionTemplate) {
            sessionTemplate.set({
                name:                   this.data.name,
                color:                  this.data.color,
                icon:                   this.data.icon,
                systemStatus:           this.data.systemStatus,
                systemType:             this.data.systemType,
                parentId:               this.data.parentId,
                shortName:              this.data.shortName,
                statusId:               this.data.statusId,
                customFields:           this.data.customFields,
                taskTypes:              this.data.taskTypes,
                projectTypeId:          this.data.projectTypeId,
                defaultView:            this.data.defaultView,
                properties:             ProjectProperties.normalize(this.data.properties),
                taskStatusesOverride:   this.data.taskStatusesOverride,
                sharedTemplateId:       this.data.sharedTemplateId,
                templateContent:        this.data.templateContent,
                statuses:               this.data.statuses,
                projectIcon:            this.data.projectIcon,
                description:            this.data.description,
                isDeleted:              this.data.isDeleted
            },{silent:true, parse:true});
            sessionTemplate.trigger("change", sessionTemplate);
        }

        const sessionProject = gd.session.projects.get(this.data.id);

        if (sessionProject) {
            sessionProject.applyDelta({
                name:                   this.data.name,
                color:                  this.data.color,
                icon:                   this.data.icon,
                systemStatus:           this.data.systemStatus,
                systemType:             this.data.systemType,
                parentId:               this.data.parentId,
                shortName:              this.data.shortName,
                statusId:               this.data.statusId,
                customFields:           this.data.customFields,
                taskTypes:              this.data.taskTypes,
                projectTypeId:          this.data.projectTypeId,
                defaultView:            this.data.defaultView,
                properties:             this.data.properties,
                taskStatusesOverride:   this.data.taskStatusesOverride,
                localTemplateId:        this.data.localTemplateId,
                templateContent:        this.data.templateContent,
                statuses:               this.data.statuses,
                projectIcon:            this.data.projectIcon,
                description:            this.data.description,
                isDeleted:              this.data.isDeleted
            })

            // yes trigger via bus ... as we start using bus only here we use it to update title in project header (project title)
            gd.bus.triggerEvent(SESSION_PROJECT_CHANGE,this.data.id)

            let statuses = this.data.taskStatusesOverride ? this.data.taskStatusesOverride : []

            await asyncSessionLoader(gd.session.findMissing({
                projects: [this.data.localTemplateId],
                statuses: statuses
            }))

            // let's recreate the tree ?
            gd.tree.resetCompanyProjects(sessionProject.companyId)
        }
    }
};